/* eslint-disable react-hooks/exhaustive-deps */

import { useState } from 'react'

import useInterval from './useInterval'

export default function useIntervalValue<T>(
  callback: () => T,
  intervalMs: number | null,
  // ^ When set to null, effectively cancels the interval
  deps: React.DependencyList,
  {
    immediate = false,
  }: {
    immediate?: boolean
  } = {}
): T {
  const [value, setValue] = useState<T>(callback())

  useInterval(
    () => {
      setValue(callback())
    },
    intervalMs,
    [deps],
    { immediate }
  )

  return value
}
